export const API_PATH_ApiAlertMgtmAlertHandlingUserDataPut = '/services/alerts-mgtm/apiAlertMgtmAlertHandlingUserDataPut';
